module.exports = __webpack_public_path__ + "img/team.fd359d4d.webp";